import React, { FC } from 'react';
import { Col, Row, Layout as AntdLayout, Grid } from 'antd';
import styles from './PublicHeader.module.scss';
import Container from '../container';
import { useTranslation } from 'react-i18next';
import { CompanyLogo } from 'components/company-logo';
import LanguageSwitcher from '../../language-switcher';
import AccessibilityButton from '../../AccessibilityToolbar/AccessibilityButton';

export const Header: FC = () => {
    const { t } = useTranslation();
    const breakpoint = Grid.useBreakpoint();

    return (
        <AntdLayout.Header className={styles.header}>
            <Container max={1200} padX={0}>
                <Row style={{ width: '100%' }} gutter={[20, 20]}>
                    <Col xs={24} lg={4} className={styles.logoColumn}>
                        <div className={styles.logoContainer}>
                            <CompanyLogo
                                href="/"
                                src="/images/moz.svg"
                                alt={t(
                                    'pages.login.state_enterprise_state_expert_center_of_the_ministry_of_health_of_ukraine_description'
                                )}
                                width={100}
                                height={48}
                            />
                        </div>
                    </Col>
                    <Col xs={24} lg={20} className={styles.buttonsColumn}>
                        <div className={styles.buttonPanel}>
                            <div className={styles.buttonOut}>
                                <AccessibilityButton />
                            </div>
                            <div className={styles.buttonOut}>
                                <LanguageSwitcher />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </AntdLayout.Header>
    );
};
